import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import withToggle from '../../../../HOCs/withToggle';
import { SYSTEM_PROP_ID } from '../../../../sic-lib/defaults';
import { ClientField } from '../../../../sic-lib/types/ClientField';
import ClientFieldsItem from '../ClientFieldsItem/ClientFieldsItem';
import ClientFieldsItemEdit from '../ClientFieldsItemEdit/ClientFieldsItemEdit';

const useStyles = makeStyles()((theme: Theme) => ({}));

const ClientFieldItemWithToggle = withToggle(ClientFieldsItem, ClientFieldsItemEdit);

interface Props {
    fieldTitle: string;
    fieldItems: ClientField[];
}

function ClientFieldsGroup({ fieldTitle, fieldItems }: Props) {
    const { classes } = useStyles();

    return (
        <Card>
            <CardHeader title={fieldTitle} />
            <Divider />
            <CardContent>
                {fieldItems.length > 0 ? (
                    fieldItems.map(
                        fld =>
                            fld.fieldId > SYSTEM_PROP_ID && (
                                <ClientFieldItemWithToggle key={fld.fieldId} config={fld} />
                            ),
                    )
                ) : (
                    <Typography component="p" variant="body2" align="center">
                        {`No ${fieldTitle}`}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}

export default ClientFieldsGroup;
